import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import ThemedBadge from '@atlassian/help-center-common-component/badges/badges';

const MENU_PADDING = grid.unitless * 6;

export const MenuItemBadge = styled(ThemedBadge)`
    float: right;
    margin-left: ${MENU_PADDING}px;
`;
